import { useEffect, useState } from "react";

/*
 * Seconds left until `until` (a ms timestamp), ticking once a second; 0 once
 * it has passed, null when there is nothing to count down. The deadline is
 * always the server's (`resend_after` / `retry_after`, Req 3).
 *
 * The value is computed from `until` on every render, never kept in state, so
 * a new deadline reads as its own countdown in the same render that sets it
 * (a stale 0 from the previous deadline would fire an auto-retry early).
 */
const remaining = (until) => (until ? Math.max(0, Math.ceil((until - Date.now()) / 1000)) : null);

const useCountdown = (until) => {
  const [, tick] = useState(0);
  useEffect(() => {
    if (!until) return undefined;
    const id = setInterval(() => {
      tick((n) => n + 1);
      if (Date.now() >= until) clearInterval(id);
    }, 1000);
    return () => clearInterval(id);
  }, [until]);
  return remaining(until);
};

// A deadline `seconds` from now, or null when the server sent none.
export const deadline = (seconds) =>
  typeof seconds === "number" && seconds > 0 ? Date.now() + seconds * 1000 : null;

export default useCountdown;
